import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'

import Login from "@/views/auth/Login";
import store from "@/store";
import ListOrganization from "@/views/Organization/ListOrganization";
import ListUser from "@/views/users/ListUser";
import process_map from "@/views/process/process_map";
import process_id from "@/views/process/proccess_id/process_id.vue";
import process_documentation_managementView
    from "@/views/process/process_documentation_management/process_documentation_managementView.vue";
import beneficiary_id from "@/views/beneficiary/beneficiary_id";
import beneficiary_map from "@/views/beneficiary/beneficiary_map";
import beneficiary_id_order_by from "@/views/beneficiary/beneficiary_id_order_by";
import process_map_print from "@/views/process/process_map_print.vue";
import process_list_id from "@/views/process/proccess_id/process_list_id.vue";
import definitions from "@/views/Financial_management_and_productivity/basic/definitions.vue";
import FaceDefinitionFinancialSituation
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituation.vue";
import ProfitAndLossStructure
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructure.vue";
import TheStructureOfTheCashFlowStatement
    from "@/views/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/TheStructureOfTheCashFlowStatement.vue";
import DefinitionOfOutput
    from "@/views/Financial_management_and_productivity/DefinitionOfOutput/DefinitionOfOutput.vue";
import DefinitionOfConsequence
    from "@/views/Financial_management_and_productivity/DefinitionOfConsequence/DefinitionOfConsequence.vue";
import DefinitionOfEffect
    from "@/views/Financial_management_and_productivity/DefinitionOfEffect/DefinitionOfEffect.vue";
import FaceDefinitionFinancialSituationChart
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationChart.vue";
import ProfitAndLossStructureChart
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureChart.vue";
import IntermediateOutcome
    from "@/views/Financial_management_and_productivity/IntermediateOutcome/IntermediateOutcome.vue";
import functional_informationView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/functional_informationView.vue";
import budget_informationView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/budget_informationView.vue";
import functional_information_FinancialView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_FinancialView.vue";
import functional_information_receivedView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_receivedView.vue";
import functional_information_ConsequencesView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_ConsequencesView.vue";
import functional_information_effectView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_effectView.vue";
import functional_information_Consequences_middleView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_Consequences_middleView.vue";
import FunctionalInformationPlanManagement
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/PlanManagement";
import FunctionalInformationLabor
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/Labor";
import budget_information_FinancialView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_FinancialView.vue";
import budget_information_receivedView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_receivedView.vue";
import budget_information_ConsequencesView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_ConsequencesView.vue";
import budget_information_Consequences_middleView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_Consequences_middleView.vue";
import budget_information_effectView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_effectView.vue";
import functional_information_wealths
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_wealths.vue";
import functional_information_debts
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_debts.vue";
import functional_information_cashes
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_cashes.vue";
import budget_information_wealths
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_wealths.vue";
import budget_information_debts
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_debts.vue";
import budget_information_profitAndLossStructures
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_profitAndLossStructures.vue";
import budget_information_cashes
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages/budget_information_cashes.vue";
import functional_information_profitAndLossStructures
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages/functional_information_profitAndLossStructures.vue";
import Problem_identification from "@/views/problem_analysis/Problem_identification/Problem_identification.vue";
import Prioritizing_issue from "@/views/problem_analysis/Prioritizing_issue/Prioritizing_issue.vue";
import The_root_causes_of_the_problem
    from "@/views/problem_analysis/The_root_causes_of_the_problem/The_root_causes_of_the_problem.vue";
import Definition_of_basic_measures
    from "@/views/problem_analysis/Definition_of_basic_measures/Definition_of_basic_measures.vue";
import Determining_the_mission
    from "@/views/Financial_management_and_productivity/Determining_the_mission/Determining_the_mission.vue";
import Definition_of_basic_measures_SupportMeasures
    from "@/views/problem_analysis/Definition_of_basic_measures/Definition_of_basic_measures_SupportMeasures.vue";
import device_monitoring_and_care
    from "@/views/problem_analysis/device_monitoring_and_care/device_monitoring_and_care.vue";
import ListMothersItems from "@/views/users/mother/ListMothersItems.vue";
import ListUserMotherById from "@/views/users/mother/ListUserMotherById.vue";
import ListOrganizationById from "@/views/Organization/ListOrganizationById.vue";
import process_map_by_id from "@/views/process/process_map_by_id.vue";
import process_list_id_by_id from "@/views/process/proccess_id/process_list_id_by_id.vue";
import process_id_by_mother from "@/views/process/proccess_id/process_id_by_mother.vue";
import job_evaluation from "@/views/process/evaluation/job_evaluation.vue";
import process_documentation_managementByIdView
    from "@/views/process/process_documentation_management/process_documentation_managementByIdView.vue";
import beneficiary_map_by_id from "@/views/beneficiary/beneficiary_map_by_id.vue";
import definitions_by_id from "@/views/Financial_management_and_productivity/basic/definitions_by_id.vue";
import FaceDefinitionFinancialSituationChartById
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationChartById.vue";
import FaceDefinitionFinancialSituationById
    from "@/views/Financial_management_and_productivity/FaceDefinitionFinancialSituation/FaceDefinitionFinancialSituationById.vue";
import ProfitAndLossStructureById
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureById.vue";
import ProfitAndLossStructureChartById
    from "@/views/Financial_management_and_productivity/ProfitAndLossStructure/ProfitAndLossStructureChartById.vue";
import TheStructureOfTheCashFlowStatementById
    from "@/views/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/TheStructureOfTheCashFlowStatementById.vue";
import DefinitionOfOutputById
    from "@/views/Financial_management_and_productivity/DefinitionOfOutput/DefinitionOfOutputById.vue";
import DefinitionOfConsequenceById
    from "@/views/Financial_management_and_productivity/DefinitionOfConsequence/DefinitionOfConsequenceById.vue";
import IntermediateOutcomeById
    from "@/views/Financial_management_and_productivity/IntermediateOutcome/IntermediateOutcomeById.vue";
import DefinitionOfEffectById
    from "@/views/Financial_management_and_productivity/DefinitionOfEffect/DefinitionOfEffectById.vue";
import PlanManagement
    from "@/views/Financial_management_and_productivity/PlanManagement";
import DataCenter
    from "@/views/Financial_management_and_productivity/DataCenter";
import functional_informationByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/functional_informationByIdView.vue";
import functional_information_FinancialByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_FinancialByIdView.vue";
import functional_information_receivedByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_receivedByIdView.vue";
import functional_information_ConsequencesByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_ConsequencesByIdView.vue";
import functional_information_Consequences_middleByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_Consequences_middleByIdView.vue";
import functional_information_effectByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_effectByIdView.vue";
import functional_information_wealthsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_wealthsById.vue";
import functional_information_debtsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_debtsById.vue";
import functional_information_profitAndLossStructuresById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_profitAndLossStructuresById.vue";
import functional_information_cashesById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_functional_information/pages_mother/functional_information_cashesById.vue";
import budget_informationByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/budget_informationByIdView.vue";
import budget_information_FinancialByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_FinancialByIdView.vue";
import budget_information_receivedByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_receivedByIdView.vue";
import budget_information_ConsequencesByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_ConsequencesByIdView.vue";
import budget_information_Consequences_middleByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_Consequences_middleByIdView.vue";
import budget_information_effectByIdView
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_effectByIdView.vue";
import budget_information_wealthsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_wealthsById.vue";
import budget_information_debtsById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_debtsById.vue";
import budget_information_profitAndLossStructuresById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_profitAndLossStructuresById.vue";
import budget_information_cashesById
    from "@/views/Financial_management_and_productivity/Financial_management_and_productivity_budget_information/pages_mother/budget_information_cashesById.vue";
import Determining_the_missionById
    from "@/views/Financial_management_and_productivity/Determining_the_mission/Determining_the_missionById.vue";
import Problem_identificationById from "@/views/problem_analysis/Problem_identification/Problem_identificationById.vue";
import Prioritizing_issueById from "@/views/problem_analysis/Prioritizing_issue/Prioritizing_issueById.vue";
import The_root_causes_of_the_problemById
    from "@/views/problem_analysis/The_root_causes_of_the_problem/The_root_causes_of_the_problemById.vue";
import Definition_of_basic_measuresById
    from "@/views/problem_analysis/Definition_of_basic_measures/mother/Definition_of_basic_measuresById.vue";
import Definition_of_basic_measures_SupportMeasuresById
    from "@/views/problem_analysis/Definition_of_basic_measures/mother/Definition_of_basic_measures_SupportMeasuresById.vue";
import device_monitoring_and_careById
    from "@/views/problem_analysis/device_monitoring_and_care/device_monitoring_and_careById.vue";
import process_documentation_managementFolderModeView
    from "@/views/process/process_documentation_management/process_documentation_managementFolderMode/process_documentation_managementFolderModeView.vue";
import Process_documentation_managementFolderModeAndFileView
    from "@/views/process/process_documentation_management/process_documentation_managementFolderMode/process_documentation_managementFolderModeAndFileView.vue";
import process_map_self from "@/views/process/process_map_self.vue";
import job_evaluation_by_id from "@/views/process/evaluation/job_evaluation_by_id.vue";
import job_evaluation_self from "@/views/process/evaluation/job_evaluation_self.vue";
import ListUserSelf from "@/views/users/mother/ListUserSelf.vue";
import ListOrganizationSelf from "@/views/Organization/ListOrganizationSelf.vue";
import settingsView from "@/views/settings/SettingsView.vue";
import SettingsUnitsView from "@/views/settings/SettingsUnitsView.vue";
import Design_and_modelingView from "@/views/process/Design_and_modeling/Design_and_modelingView.vue";
import indexMatrixView from "@/views/Matrix_Connections/indexMatrixView.vue";
import Matrix_Connections_include from "@/views/Matrix_Connections/Matrix_Connections_include.vue";
import Matrix_Connections_exit from "@/views/Matrix_Connections/Matrix_Connections_exit.vue";
import Matrix_Connections_includeBy from "@/views/Matrix_Connections/includes/Matrix_Connections_includeBy.vue";
import Matrix_Connections_exitBy from "@/views/Matrix_Connections/exits/Matrix_Connections_exitBy.vue";
import RolesAndResponsibilitiesView from "@/views/RolesAndResponsibilities/RolesAndResponsibilitiesView.vue";
import Productivity_periodView from "@/views/settings/Productivity_period/Productivity_periodView.vue";
import RolesAndResponsibilitiesByIdView from "@/views/RolesAndResponsibilities/RolesAndResponsibilitiesByIdView.vue";
import beneficiary_id_by_process from "@/views/beneficiary/beneficiary_id_by_process.vue";
import indexMatrixMotherView from "@/views/Matrix_Connections_mother/indexMatrixMotherView.vue";
import Matrix_Connections_includeMother from "@/views/Matrix_Connections_mother/Matrix_Connections_includeMother.vue";
import Matrix_Connections_exitMother from "@/views/Matrix_Connections_mother/Matrix_Connections_exitMother.vue";
import Matrix_Connections_includeByMother
    from "@/views/Matrix_Connections_mother/includes/Matrix_Connections_includeByMother.vue";
import Matrix_Connections_exitByMother
    from "@/views/Matrix_Connections_mother/exits/Matrix_Connections_exitByMother.vue";
import basic_defined_strategic_management
    from "@/views/strategic_managment/default/basic_defined_strategic_management.vue";
import Strategic_readiness_assessment from "@/views/strategic_managment/default/Strategic_readiness_assessment.vue";
import strategic_planning from "@/views/strategic_managment/default/strategic_planning.vue";
import Strategic_current from "@/views/strategic_managment/default/Strategic_current.vue";
import Strategic_relations from "@/views/strategic_managment/default/Strategic_relations.vue";
import beneficiary_Expertise from "@/views/beneficiary/beneficiary_Expertise.vue";
import basic_defined_strategic_management_mother
    from "@/views/strategic_managment/mother/basic_defined_strategic_management_mother.vue";
import Vision_working_group from "@/views/strategic_managment/default/Vision_working_group/Vision_working_group.vue";
import Vision_working_group_Questions
    from "@/views/strategic_managment/default/Vision_working_group/Vision_working_group_Questions.vue";
import Vision_working_group_Suggested_perspective
    from "@/views/strategic_managment/default/Vision_working_group/Vision_working_group_Suggested_perspective.vue";
import Vision_working_group_Gary_Hamel_questionnaireIndex
    from "@/views/strategic_managment/default/Vision_working_group/Vision_working_group_Gary_Hamel_questionnaireIndex.vue";
import Vision_working_group_future
    from "@/views/strategic_managment/default/Vision_working_group/Vision_working_group_future.vue";
import Vision_working_group_Gary_Hamel_questionnaireIndexByType
    from "@/views/strategic_managment/default/Vision_working_group/Vision_working_group_Gary_Hamel_questionnaireIndexByType.vue";
import Vision_working_group_futureInputs
    from "@/views/strategic_managment/default/Vision_working_group/Vision_working_group_futureInputs.vue";
import executive_elementsView from "@/views/strategic_managment/default/executive_elements/executive_elementsView.vue";
import executive_elements_habitsView
    from "@/views/strategic_managment/default/executive_elements/executive_elements_habitsView.vue";
import fiveFView from "@/views/5_f/fiveFView.vue";
import fiveF_step_OneView from "@/views/5_f/fiveF_step_OneView.vue";
import fiveF_step_TwoView from "@/views/5_f/fiveF_step_TwoView.vue";
import pestel_main from "@/views/strategic_managment/default/pestel/pestel_main.vue";
import beneficiary_periodView from "@/views/beneficiary/beneficiary_periodView.vue";
import pestel_step_one from "@/views/strategic_managment/default/pestel/pestel_step_one.vue";
import pestel_step_two from "@/views/strategic_managment/default/pestel/pestel_step_two.vue";
import beneficiary_id_order_by_power from "@/views/beneficiary/beneficiary_id_order_by_power.vue";
import beneficiary_id_order_by_Mitchell from "@/views/beneficiary/beneficiary_id_order_by_Mitchell.vue";
import beneficiary_id_order_by_power_for_management
    from "@/views/beneficiary/beneficiary_id_order_by_power_for_management.vue";
import beneficiary_id_order_by_power_for_management_chart
    from "@/views/beneficiary/beneficiary_id_order_by_power_for_management_chart.vue";
import pestel_matrices_efe from "@/views/strategic_managment/default/pestel/pestel_matrices_efe.vue";
import pestel_matrices_attractiveness
    from "@/views/strategic_managment/default/pestel/pestel_matrices_attractiveness.vue";
import beneficiary_id_order_by_mitchell_for_management
    from "@/views/beneficiary/beneficiary_id_order_by_mitchell_for_management.vue";
import beneficiary_id_order_by_mitchell_for_management_circle
    from "@/views/beneficiary/beneficiary_id_order_by_mitchell_for_management_circle.vue";
import beneficiary_id_order_by_mitchell_for_management_table
    from "@/views/beneficiary/beneficiary_id_order_by_mitchell_for_management_table.vue";
import aboutView from "@/views/settings/aboutView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import ticketView from "@/views/tickets/ticketView.vue";
import ticketDetailView from "@/views/tickets/ticketDetailView.vue";
import beneficiary_analytics from "@/views/beneficiary/beneficiary_analytics.vue";
import organ_unitsView from "@/views/organ_units/organ_unitsView.vue";
import beneficiary_analytics_index from "@/views/beneficiary/beneficiary_analytics_index.vue";
import ListOrganizationPublicMode from "@/views/Organization/ListOrganizationPublicMode.vue";
import settingsPeriodSystemView from "@/views/settings/settingsPeriodSystemView.vue";
import ListOrganizationCharts from "@/views/Organization/ListOrganizationCharts.vue";
import organ_unitsChartsView from "@/views/organ_units/organ_unitsChartsView.vue";
import executive_elementsChartView
    from "@/views/strategic_managment/default/executive_elements/executive_elementsChartView.vue";
import device_monitoring_and_care_backup
    from "@/views/problem_analysis/device_monitoring_and_care_backup/device_monitoring_and_care_backup.vue";
import device_monitoring_and_care_backup_ById
    from "@/views/problem_analysis/device_monitoring_and_care_backup/device_monitoring_and_care_backup_ById.vue";
import JobDescription from "@/views/Organization/JobId/JobDescription.vue";
import executive_elementsByIdView
    from "@/views/strategic_managment/mother/executive_elements/executive_elementsByIdView.vue";
import executive_elementsChartByIdView
    from "@/views/strategic_managment/mother/executive_elements/executive_elementsChartByIdView.vue";
import settingsPeriodSystemCircleView from "@/views/settings/settingsPeriodSystemCircleView.vue";
import Productivity_periodCircleView
    from "@/views/settings/Productivity_period_circle/Productivity_periodCircleView.vue";
import Impact_Assessment from "@/views/problem_analysis/Impact_Assessment/Impact_Assessment.vue";
import Impact_Assessment_by from "@/views/problem_analysis/Impact_Assessment/Impact_Assessment_by.vue";
import beneficiary_analytics_index_by_beneficiary
    from "@/views/beneficiary/beneficiary_analytics_index_by_beneficiary.vue";
import beneficiary_analytics_index_by_process from "@/views/beneficiary/beneficiary_analytics_index_by_process.vue";
import DefineProductivityRepresentations
    from "@/views/Financial_management_and_productivity/DefineProductivityRepresentations/index.vue";
import MaterialsDefinition from "@/views/Financial_management_and_productivity/MaterialsDefinition/index.vue";
import ProductsDefinition from "@/views/Financial_management_and_productivity/ProductsDefinition/index.vue";
import EnergyDefinition from "@/views/Financial_management_and_productivity/EnergyDefinition/index.vue";
import DefineAdjustmentCoefficients
    from "@/views/Financial_management_and_productivity/DefineAdjustmentCoefficients/index.vue";
import MaterialAdjustmentCoefficients
    from "@/views/Financial_management_and_productivity/DefineAdjustmentCoefficients/MaterialAdjustmentCoefficients/index.vue";
import ProductsAdjustmentCoefficients
    from "@/views/Financial_management_and_productivity/DefineAdjustmentCoefficients/ProductsAdjustmentCoefficients/index.vue";
import EnergyAdjustmentCoefficients
    from "@/views/Financial_management_and_productivity/DefineAdjustmentCoefficients/EnergyAdjustmentCoefficients/index.vue";
import EconomicOperationReport from "@/views/PerformanceManagement/EconomicOperationReport/index.vue";
import KavehPars from "@/views/PerformanceManagement/EconomicOperationReport/KavehPars/index.vue";
import ProductivityImprovementProgram from "@/views/planning_and _monitoring _the_efficiency_of_government_services/productivity_improvement_program.vue";

const routes = [
    // default
    {
        path: '/mother_items',
        name: 'mother_items',
        component: ListMothersItems,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}


    },
    // pishkhan
    {
        path: '/pishkhan',
        name: 'home',
        component: HomeView,
        meta: {requiredAuth: true,}


    },
//    user **************************************************

    {
        path: '/pishkhan/list/user',
        name: 'list_user',
        component: ListUser,
        meta: {requiredAuth: true}


    },
    {
        path: '/pishkhan/list/user_self',
        name: 'list_user_self',
        component: ListUserSelf,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}


    },
    {
        path: '/pishkhan/list/user/by/:id/:title',
        name: 'list_user_mother',
        component: ListUserMotherById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}


    },
    {
        path: '/pishkhan/Organization/list',
        name: 'list_organic',
        component: ListOrganization,
        meta: {requiredAuth: true,}


    }, {
        path: '/pishkhan/Organization/list/public',
        name: 'list_organic_public',
        component: ListOrganizationPublicMode,
        meta: {requiredAuth: true,}


    },
    {
        path: '/pishkhan/Organization/list/Charts',
        name: 'ListOrganizationCharts',
        component: ListOrganizationCharts,
        meta: {requiredAuth: true,}


    },

    {
        path: '/pishkhan/Organization/units',
        name: 'organ_units',
        component: organ_unitsView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}


    }, {
        path: '/pishkhan/Organization/units/chart',
        name: 'organ_units_chart',
        component: organ_unitsChartsView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}


    },
    {
        path: '/pishkhan/Organization/list_self',
        name: 'list_organic_self',
        component: ListOrganizationSelf,
        meta: {requiredAuth: true,}


    },
    {
        path: '/pishkhan/Organization/list/by/:id/:title',
        name: 'list_organic_mother',
        component: ListOrganizationById,
        meta: {requiredAuth: true,}


    },
//  auth   **************************************************

    {
        path: '/',
        name: 'login',
        component: Login,
        meta: {loginRedirect: true}

    },
    // process
//     **************************************************

    {
        path: '/process/map',
        name: 'process_map',
        component: process_map,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    }, {
        path: '/process/map_self',
        name: 'process_map_self',
        component: process_map_self,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/process/map/by/:id/:title',
        name: 'process_map_by_id',
        component: process_map_by_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/process/map/print',
        name: 'process_map_print',
        component: process_map_print,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },

    {
        path: '/process/id',
        name: 'process_id',
        component: process_list_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/process/id/by/:id/:title',
        name: 'process_id_by_id',
        component: process_list_id_by_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/process/id/complete/:id',
        name: 'process_id_complete',
        component: process_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/process/id/complete/by_mother/:id/:title',
        name: 'process_id_complete_by_mother',
        component: process_id_by_mother,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/settings',
        name: 'settings',
        component: settingsView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/settings/period_system',
        name: 'settings_period_system',
        component: settingsPeriodSystemView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },

    {
        path: '/settings/about',
        name: 'about',
        component: aboutView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/settings/units',
        name: 'settings_units',
        component: SettingsUnitsView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/job/evaluation',
        name: 'job_evaluation',
        component: job_evaluation,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/job/evaluation/by/:id/:title',
        name: 'job_evaluation_by_id',
        component: job_evaluation_by_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/job/evaluation/by/self',
        name: 'job_evaluation_by_self',
        component: job_evaluation_self,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/Process/documentation/management',
        name: 'process_documentation_management',
        component: process_documentation_managementView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/Process/documentation/management/FolderMode',
        name: 'process_documentation_management_FolderMode',
        component: process_documentation_managementFolderModeView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/Process/documentation/management/FolderAndFileMode/:id',
        name: 'process_documentation_management_FolderAndFileMode',
        component: Process_documentation_managementFolderModeAndFileView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
    {
        path: '/Process/documentation/management/by/:id/:title',
        name: 'process_documentation_management_by_id',
        component: process_documentation_managementByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},


    },
//     **************************************************

    //Beneficiary
    {
        path: '/beneficiary/map',
        name: 'beneficiary_map',
        component: beneficiary_map,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/map/by/:id/:title',
        name: 'beneficiary_map_by_id',
        component: beneficiary_map_by_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/id',
        name: 'beneficiary_id',
        component: beneficiary_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary_period',
        name: 'beneficiary_period',
        component: beneficiary_periodView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },

    {
        path: '/beneficiary/index',
        name: 'beneficiary_index',
        component: beneficiary_id_by_process,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    }, {
        path: '/beneficiary/Expertise',
        name: 'beneficiary_Expertise',
        component: beneficiary_Expertise,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/order_by',
        name: 'beneficiary_id_order_by',
        component: beneficiary_id_order_by,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/order_by/power',
        name: 'beneficiary_id_order_by_power',
        component: beneficiary_id_order_by_power,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/order_by/power_for_management',
        name: 'beneficiary_id_order_by_power_for_management',
        component: beneficiary_id_order_by_power_for_management,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    }, {
        path: '/beneficiary/order_by/power_for_management_chart',
        name: 'beneficiary_id_order_by_power_for_management_chart',
        component: beneficiary_id_order_by_power_for_management_chart,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/order_by/Mitchell',
        name: 'beneficiary_id_order_by_Mitchell',
        component: beneficiary_id_order_by_Mitchell,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/order_by/mitchell_for_management',
        name: 'beneficiary_id_order_by_mitchell_for_management',
        component: beneficiary_id_order_by_mitchell_for_management,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary/order_by/mitchell_for_management_circle',
        name: 'beneficiary_id_order_by_mitchell_for_management_circle',
        component: beneficiary_id_order_by_mitchell_for_management_circle,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    }, {
        path: '/beneficiary/order_by/mitchell_for_management_table',
        name: 'beneficiary_id_order_by_mitchell_for_management_table',
        component: beneficiary_id_order_by_mitchell_for_management_table,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },

    {
        path: '/beneficiary_analytics',
        name: 'beneficiary_analytics',
        component: beneficiary_analytics_index,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/beneficiary_analytics_by_beneficiary',
        name: 'beneficiary_analytics_by_beneficiary',
        component: beneficiary_analytics_index_by_beneficiary,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    }, {
        path: '/beneficiary_analytics_by_process',
        name: 'beneficiary_analytics_by_process',
        component: beneficiary_analytics_index_by_process,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },


//    Financial management and productivity **************************************************
    {
        path: '/Financial_management_and_productivity/definitions',
        name: 'Financial_management_and_productivity_definitions',
        component: definitions,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/definitions/by/:id/:title',
        name: 'Financial_management_and_productivity_definitions_by',
        component: definitions_by_id,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/Determining_the_mission',
        name: 'Financial_management_and_productivity_Determining_the_mission',
        component: Determining_the_mission,
        meta: {requiredAuth: true}

    },
    {
        path: '/Financial_management_and_productivity/Determining_the_mission/By/:id/:title',
        name: 'Financial_management_and_productivity_Determining_the_missionById',
        component: Determining_the_missionById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation',
        component: FaceDefinitionFinancialSituation,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation/by/:id/:title',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_by_id',
        component: FaceDefinitionFinancialSituationById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation/chart',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_chart',
        component: FaceDefinitionFinancialSituationChart,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/FaceDefinitionFinancialSituation/chart/by/:id/:title',
        name: 'Financial_management_and_productivity_definitions_FaceDefinitionFinancialSituation_chart_by_id',
        component: FaceDefinitionFinancialSituationChartById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure',
        component: ProfitAndLossStructure,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure/by/:id/:title',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure_by_id',
        component: ProfitAndLossStructureById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure/chart',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure_chart',
        component: ProfitAndLossStructureChart,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/ProfitAndLossStructure/chart/by/:id/:title',
        name: 'Financial_management_and_productivity_ProfitAndLossStructure_chart_by_id',
        component: ProfitAndLossStructureChartById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement',
        name: 'Financial_management_and_productivity_TheStructureOfTheCashFlowStatement',
        component: TheStructureOfTheCashFlowStatement,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/by/:id/:title',
        name: 'Financial_management_and_productivity_TheStructureOfTheCashFlowStatement_by_id',
        component: TheStructureOfTheCashFlowStatementById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfOutput',
        name: 'Financial_management_and_productivity_DefinitionOfOutput',
        component: DefinitionOfOutput,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfOutput/by/:id/:title',
        name: 'Financial_management_and_productivity_DefinitionOfOutput_by_id',
        component: DefinitionOfOutputById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfConsequence',
        name: 'Financial_management_and_productivity_DefinitionOfConsequence',
        component: DefinitionOfConsequence,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Impact_Assessment',
        name: 'Impact_Assessment',
        component: Impact_Assessment,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    }, {
        path: '/Impact_Assessment/by/:id/:title',
        name: 'Impact_Assessment_by',
        component: Impact_Assessment_by,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/performance-management/economic-operation-report',
        name: 'performance_management_economic_operation_report',
        component: EconomicOperationReport,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}
    },
    {
        path: '/performance-management/economic-operation-report/holdings/kaveh-pars',
        name: 'performance_management_economic_operation_report_holdings_kaveh_pars',
        component: KavehPars,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}
    },

    {
        path: '/Financial_management_and_productivity/DefinitionOfConsequence/by/:id/:title',
        name: 'Financial_management_and_productivity_DefinitionOfConsequenceById',
        component: DefinitionOfConsequenceById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/IntermediateOutcome',
        name: 'Financial_management_and_productivity_IntermediateOutcome',
        component: IntermediateOutcome,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    }, {
        path: '/Financial_management_and_productivity/IntermediateOutcome/by/:id/:title',
        name: 'Financial_management_and_productivity_IntermediateOutcomeById',
        component: IntermediateOutcomeById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfEffect',
        name: 'Financial_management_and_productivity_DefinitionOfEffect',
        component: DefinitionOfEffect,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/DefinitionOfEffect/by/:id/:title',
        name: 'Financial_management_and_productivity_DefinitionOfEffectById',
        component: DefinitionOfEffectById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}
    },
    {
        path: '/Financial_management_and_productivity/plan-management',
        name: 'Financial_management_and_productivity_plan_management',
        component: PlanManagement,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}
    },
    {
        path: '/Financial_management_and_productivity/data-center',
        name: 'Financial_management_and_productivity_data_center',
        component: DataCenter,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}
    },

    // functional_informationView
    {
        path: '/Financial_management_and_productivity/functional_information',
        name: 'Financial_management_and_productivity_functional_information',
        component: functional_informationView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_informationById',
        component: functional_informationByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Financial',
        name: 'Financial_management_and_productivity_functional_information_Financial',
        component: functional_information_FinancialView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    {
        path: '/Financial_management_and_productivity/functional_information/Financial/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_FinancialById',
        component: functional_information_FinancialByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },


    {
        path: '/Financial_management_and_productivity/functional_information/received',
        name: 'Financial_management_and_productivity_functional_information_received',
        component: functional_information_receivedView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/received/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_received_by_id',
        component: functional_information_receivedByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    {
        path: '/Financial_management_and_productivity/functional_information/Consequences',
        name: 'Financial_management_and_productivity_functional_information_Consequences',
        component: functional_information_ConsequencesView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Consequences/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_ConsequencesById',
        component: functional_information_ConsequencesByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Consequences/middle',
        name: 'Financial_management_and_productivity_functional_information_Consequences_middle',
        component: functional_information_Consequences_middleView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/Consequences/middle/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_Consequences_middle_by_id',
        component: functional_information_Consequences_middleByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    {
        path: '/Financial_management_and_productivity/functional_information/effect',
        name: 'Financial_management_and_productivity_functional_information_effect',
        component: functional_information_effectView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/effect/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_effectById',
        component: functional_information_effectByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/wealths',
        name: 'Financial_management_and_productivity_functional_information_wealths',
        component: functional_information_wealths,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/wealths/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_wealthsById',
        component: functional_information_wealthsById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/debts',
        name: 'Financial_management_and_productivity_functional_information_debts',
        component: functional_information_debts,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/debts/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_debtsById',
        component: functional_information_debtsById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/profit_and_loss_structures',
        name: 'Financial_management_and_productivity_functional_information_profitAndLossStructures',
        component: functional_information_profitAndLossStructures,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/profit_and_loss_structures/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_profitAndLossStructuresById',
        component: functional_information_profitAndLossStructuresById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/cashes',
        name: 'Financial_management_and_productivity_functional_information_cashes',
        component: functional_information_cashes,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/cashes/by/:id/:title',
        name: 'Financial_management_and_productivity_functional_information_cashesById',
        component: functional_information_cashesById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/plan-management',
        name: 'Financial_management_and_productivity_functional_information_plan_management',
        component: FunctionalInformationPlanManagement,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/functional_information/labor',
        name: 'Financial_management_and_productivity_functional_information_labor',
        component: FunctionalInformationLabor,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    // budget_informationView
    {
        path: '/Financial_management_and_productivity/budget_information',
        name: 'Financial_management_and_productivity_budget_information',
        component: budget_informationView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/budget_information/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_informationById',
        component: budget_informationByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show}

    },
    {
        path: '/Financial_management_and_productivity/budget_information/Financial',
        name: 'Financial_management_and_productivity_budget_information_Financial',
        component: budget_information_FinancialView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Financial/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_FinancialById',
        component: budget_information_FinancialByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/received',
        name: 'Financial_management_and_productivity_budget_information_received',
        component: budget_information_receivedView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/received/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_receivedById',
        component: budget_information_receivedByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_ConsequencesById',
        component: budget_information_ConsequencesByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences',
        name: 'Financial_management_and_productivity_budget_information_Consequences',
        component: budget_information_ConsequencesView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences/middle/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_Consequences_middleById',
        component: budget_information_Consequences_middleByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/Consequences/middle',
        name: 'Financial_management_and_productivity_budget_information_Consequences_middle',
        component: budget_information_Consequences_middleView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/effect/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_effectById',
        component: budget_information_effectByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/effect',
        name: 'Financial_management_and_productivity_budget_information_effect',
        component: budget_information_effectView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/wealths/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_wealthsById',
        component: budget_information_wealthsById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/wealths',
        name: 'Financial_management_and_productivity_budget_information_wealths',
        component: budget_information_wealths,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/debts/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_debtsById',
        component: budget_information_debtsById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    {
        path: '/Financial_management_and_productivity/budget_information/debts',
        name: 'Financial_management_and_productivity_budget_information_debts',
        component: budget_information_debts,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/profit_and_loss_structures',
        name: 'Financial_management_and_productivity_budget_information_profitAndLossStructures',
        component: budget_information_profitAndLossStructures,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/profit_and_loss_structures/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_profitAndLossStructuresById',
        component: budget_information_profitAndLossStructuresById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/cashes',
        name: 'Financial_management_and_productivity_budget_information_cashes',
        component: budget_information_cashes,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/budget_information/cashes/by/:id/:title',
        name: 'Financial_management_and_productivity_budget_information_cashesById',
        component: budget_information_cashesById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    // Define adjustment coefficients
    {
        path: '/Financial_management_and_productivity/define-adjustment-coefficients',
        name: 'Financial_management_and_productivity_define_adjustment_coefficients',
        component: DefineAdjustmentCoefficients,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/define-adjustment-coefficients/material',
        name: 'Financial_management_and_productivity_define_adjustment_coefficients_material',
        component: MaterialAdjustmentCoefficients,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/define-adjustment-coefficients/products',
        name: 'Financial_management_and_productivity_define_adjustment_coefficients_products',
        component: ProductsAdjustmentCoefficients,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Financial_management_and_productivity/define-adjustment-coefficients/energy',
        name: 'Financial_management_and_productivity_define_adjustment_coefficients_energy',
        component: EnergyAdjustmentCoefficients,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    // Define productivity representations
    {
        path: '/Financial_management_and_productivity/define-productivity-representations',
        name: 'Financial_management_and_productivity_define_productivity_representations',
        component: DefineProductivityRepresentations,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    // Materials Definition
    {
        path: '/Financial_management_and_productivity/materials-definition',
        name: 'Financial_management_and_productivity_materials_definition',
        component: MaterialsDefinition,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    // Products Definition
    {
        path: '/Financial_management_and_productivity/products-definition',
        name: 'Financial_management_and_productivity_products_definition',
        component: ProductsDefinition,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    // Energy Definition
    {
        path: '/Financial_management_and_productivity/energy-definition',
        name: 'Financial_management_and_productivity_energy_definition',
        component: EnergyDefinition,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    //problem analysis
    {
        path: '/problem_analysis/Problem_identification',
        name: 'problem_analysis_Problem_identification',
        component: Problem_identification,
        meta: {requiredAuth: true,},
    },
    {
        path: '/problem_analysis/Problem_identification/by/:id/:title',
        name: 'problem_analysis_Problem_identificationById',
        component: Problem_identificationById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/problem_analysis/Prioritizing_issue',
        name: 'problem_analysis_Prioritizing_issue',
        component: Prioritizing_issue,
        meta: {requiredAuth: true,},
    },
    {
        path: '/problem_analysis/Prioritizing_issue/by/:id/:title',
        name: 'problem_analysis_Prioritizing_issueById',
        component: Prioritizing_issueById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/problem_analysis/The_root_causes_of_the_problem',
        name: 'problem_analysis_The_root_causes_of_the_problem',
        component: The_root_causes_of_the_problem,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/The_root_causes_of_the_problem/by/:id/:title',
        name: 'problem_analysis_The_root_causes_of_the_problemById',
        component: The_root_causes_of_the_problemById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures',
        name: 'problem_analysis_Definition_of_basic_measures',
        component: Definition_of_basic_measures,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures/by/:id/:title',
        name: 'problem_analysis_Definition_of_basic_measuresById',
        component: Definition_of_basic_measuresById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures/SupportMeasures',
        name: 'problem_analysis_Definition_of_basic_measures_SupportMeasures',
        component: Definition_of_basic_measures_SupportMeasures,
        meta: {requiredAuth: true},
    },
    {
        path: '/problem_analysis/Definition_of_basic_measures/SupportMeasures/by/:id/:title',
        name: 'problem_analysis_Definition_of_basic_measures_SupportMeasuresById',
        component: Definition_of_basic_measures_SupportMeasuresById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/problem_analysis/device_monitoring_and_care',
        name: 'problem_analysis_device_monitoring_and_care',
        component: device_monitoring_and_care,
        meta: {requiredAuth: true,},
    },
    {
        path: '/problem_analysis/device_monitoring_and_care/by/:id/:title',
        name: 'problem_analysis_device_monitoring_and_careById',
        component: device_monitoring_and_careById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/problem_analysis/device_monitoring_and_care/by/backup/:id/:title',
        name: 'problem_analysis_device_monitoring_and_careById_backup',
        component: device_monitoring_and_care_backup_ById,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/problem_analysis/device_monitoring_and_care/backup_action',
        name: 'problem_analysis_device_monitoring_and_care_backup_action',
        component: device_monitoring_and_care_backup,
        meta: {requiredAuth: true,},
    },
    //Design_and_modeling
    {
        path: '/Design_and_modeling',
        name: 'Design_and_modeling',
        component: Design_and_modelingView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    //Matrix_Connections

    {
        path: '/Matrix_Connections',
        name: 'Matrix_Connections',
        component: indexMatrixView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Matrix_Connections/by/:id/:title',
        name: 'Matrix_Connections_by',
        component: indexMatrixMotherView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Matrix_Connections/include',
        name: 'Matrix_Connections_include',
        component: Matrix_Connections_include,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/Matrix_Connections/include/by/:title/:id',
        name: 'Matrix_Connections_include_by_mother_item',
        component: Matrix_Connections_includeMother,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Matrix_Connections/include/by/:type',
        name: 'Matrix_Connections_include_by',
        component: Matrix_Connections_includeBy,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/Matrix_Connections/include/by/:type/:title/:id',
        name: 'Matrix_Connections_include_by_mother_include',
        component: Matrix_Connections_includeByMother,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Matrix_Connections/exit/by/:title/:id',
        name: 'Matrix_Connections_exit_by_mother_item',
        component: Matrix_Connections_exitMother,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Matrix_Connections/exit',
        name: 'Matrix_Connections_exit',
        component: Matrix_Connections_exit,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Matrix_Connections/exit/by/:type',
        name: 'Matrix_Connections_exit_by',
        component: Matrix_Connections_exitBy,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/Matrix_Connections/exit/by/:type/:title/:id',
        name: 'Matrix_Connections_exit_by_mother_exit',
        component: Matrix_Connections_exitByMother,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/RolesAndResponsibilities',
        name: 'RolesAndResponsibilities',
        component: RolesAndResponsibilitiesView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/RolesAndResponsibilities/by/:id/:title',
        name: 'RolesAndResponsibilities_by_id',
        component: RolesAndResponsibilitiesByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    {
        path: '/Productivity_period',
        name: 'Productivity_period',
        component: Productivity_periodView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/Productivity_period_circle',
        name: 'Productivity_period_circle',
        component: Productivity_periodView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    // Strategic Management
    {
        path: '/strategicManagement/basic_defined',
        name: 'strategicManagement_basic_defined',
        component: basic_defined_strategic_management,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/strategicManagement/basic_defined_strategic_management_mother/:id/:title',
        name: 'basic_defined_strategic_management_mother',
        component: basic_defined_strategic_management_mother,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Strategic_readiness_assessment',
        name: 'Strategic_readiness_assessment',
        component: Strategic_readiness_assessment,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/strategic_planning',
        name: 'strategic_planning',
        component: strategic_planning,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Strategic_current',
        name: 'Strategic_current',
        component: Strategic_current,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Strategic_relations',
        name: 'Strategic_relations',
        component: Strategic_relations,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Vision_working_group',
        name: 'Vision_working_group',
        component: Vision_working_group,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Vision_working_group_Questions',
        name: 'Vision_working_group_Questions',
        component: Vision_working_group_Questions,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/Vision_working_group_Suggested_perspective',
        name: 'Vision_working_group_Suggested_perspective',
        component: Vision_working_group_Suggested_perspective,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    {
        path: '/Vision_working_group_Gary_Hamel_questionnaire/ByType',
        name: 'Vision_working_group_Gary_Hamel_questionnaireByType',
        component: Vision_working_group_Gary_Hamel_questionnaireIndexByType,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/Vision_working_group_future',
        name: 'Vision_working_group_future',
        component: Vision_working_group_future,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/executive_elements',
        name: 'executive_elements',
        component: executive_elementsView,
        meta: {requiredAuth: true,},
    }, {
        path: '/executive_elements/by/:id/:title',
        name: 'executive_elements_by_id',
        component: executive_elementsByIdView,
        meta: {requiredAuth: true,},
    },

    {
        path: '/executive_elements/chart/by/:id/:title',
        name: 'executive_elements_chart_by_id',
        component: executive_elementsChartByIdView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/executive_elements/chart',
        name: 'executive_elements_chart',
        component: executive_elementsChartView,
        meta: {requiredAuth: true,},
    },
    {
        path: '/executive_elements/habits/:id/:name',
        name: 'executive_elements_habits',
        component: executive_elements_habitsView,
        meta: {requiredAuth: true,},
    },
    {
        path: '/5_f/intro',
        name: '5_f',
        component: fiveFView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/5_f/step_1',
        name: '5_f_step_one',
        component: fiveF_step_OneView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/5_f/step_2',
        name: '5_f_step_two',
        component: fiveF_step_TwoView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/pestel',
        name: 'pestel',
        component: pestel_main,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/pestel_step_1',
        name: 'pestel_step_one',
        component: pestel_step_one,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/pestel_step_2',
        name: 'pestel_step_two',
        component: pestel_step_two,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    }, {
        path: '/pestel_matrices_efe',
        name: 'pestel_matrices_efe',
        component: pestel_matrices_efe,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/pestel_matrices_attractiveness',
        name: 'pestel_matrices_attractiveness',
        component: pestel_matrices_attractiveness,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/ticket',
        name: 'ticket',
        component: ticketView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    {
        path: '/ticket/detail/:id',
        name: 'ticket_detail',
        component: ticketDetailView,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },

    

    {
        path: '/:catchAll(.*)',
        name: 'NotFound',
        component: NotFoundView,
        meta: {
            layout: 'EmptyLayout'  // اگر نیاز به یک layout خاص دارید
        }
    },


    {
        path: '/job-description/:organizationId/:step?',
        name: 'job_description',
        component: JobDescription,
    },

{
        path: '/productivity_improvement_program',
        name: 'productivity_improvement_program',
        component: ProductivityImprovementProgram,
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    // *********************************************** Risk ******************************************
    {
        path: '/risk-management/risk-planning',
        name: 'risk_management.risk_planning',
        component: () => import("@/views/RiskManagement/RiskPlanning"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/risk-management/risk-planning/risk-charter',
        name: 'risk_management.risk_planning.risk_charter',
        component: () => import("@/views/RiskManagement/RiskPlanning/RiskCharter"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/risk-management/risk-planning/risk-policy',
        name: 'risk_management.risk_planning.risk_policy',
        component: () => import("@/views/RiskManagement/RiskPlanning/RiskPolicy"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/risk-management/risk-planning/risk-statement/:step?',
        name: 'risk_management.risk_planning.risk_statement',
        component: () => import("@/views/RiskManagement/RiskPlanning/RiskStatement"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/risk-management/risk-planning/risk-statement/risk-components/risk-description/:id?',
        name: 'risk_management.risk_planning.risk_statement.risk_components.risk_description',
        component: () => import("@/views/RiskManagement/RiskPlanning/RiskStatement/RiskDescription.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/risk-management/risk-planning/risk-statement/business-rules/:id?',
        name: 'risk_management.risk_planning.risk_statement.business_rules',
        component: () => import("@/views/RiskManagement/RiskPlanning/RiskStatement/RiskTypeDetail.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    {
        path: '/risk-management/risk-planning/risk-statement/risk-appetite/:id?',
        name: 'risk_management.risk_planning.risk_statement.risk_appetite',
        component: () => import("@/views/RiskManagement/RiskPlanning/RiskStatement/RiskAppetite.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},
    },
    // ******************* Strategic ******************************************

    {
        path: '/strategic-planning/general-success-factors/:organizationId/:step?',
        name: 'strategic_planning.general_success',
        component: () => import("@/views/StrategicPlanning/GeneralSuccessFactors.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},

    },
    {
        path: '/strategic-planning/cpm/:organizationId/:step?',
        name: 'strategic_planning.cpm',
        component: () => import("@/views/StrategicPlanning/CPM.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},

    },
    {
        path: '/strategic-planning/rbv/:organizationId/:step?',
        name: 'strategic_planning.rbv',
        component: () => import("@/views/StrategicPlanning/RBV/index.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},

    },
    {
        path: '/strategic-planning/rbv/exist/:organizationId/:step?',
        name: 'strategic_planning.rbv.exist',
        component: () => import("@/views/StrategicPlanning/RBV/ExistRBV.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},

    },
    {
        path: '/strategic-planning/rbv/non-exist/:organizationId/:step?',
        name: 'strategic_planning.rbv.non_exist',
        component: () => import("@/views/StrategicPlanning/RBV/NonExistRBV.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},

    },


    {
        path: '/strategic-planning/rbv/non-exist/:organizationId/:step?',
        name: 'strategic_planning.rbv.non_exist',
        component: () => import("@/views/StrategicPlanning/RBV/NonExistRBV.vue"),
        meta: {requiredAuth: true, is_show: () => store.state.is_show},

    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})
router.beforeEach((to, from, next) => {
    // اطمینان از به‌روز بودن وضعیت احراز هویت
    store.commit('onStart')

    // بررسی is_show برای مسیر فعلی
    const isShowForRoute = to.matched.some(record => {
        // اگر is_show یک تابع باشد، آن را فراخوانی می‌کنیم
        const isShowValue = typeof record.meta.is_show === 'function'
            ? record.meta.is_show()
            : record.meta.is_show

        return isShowValue === false
    })

    if (isShowForRoute) {
        next('/pishkhan')
        return
    }

    // بررسی احراز هویت مورد نیاز
    if (to.matched.some(record => record.meta.requiredAuth)) {
        if (store.state.isAuth) {
            next()
        } else {
            next('/')
        }
    } else if (to.matched.some(record => record.meta.loginRedirect)) {
        if (!store.state.isAuth) {
            next()
        } else {
            next('/pishkhan')
        }
    } else {
        next()
    }
})

export default router
